import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../../apis/store";
import { useEffect } from "react";
import { toGetNews } from "../../../apis/actions/news.actions";
import moment from "moment";
import "moment/locale/ar";
import { HOME_WOW_DURATION, homeWowDelay } from "../../../utils/homeWow";

const Blog = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { list } = useSelector((state: RootState) => state.news.news);
  useEffect(() => {
    dispatch(toGetNews(i18n.language));
  }, [dispatch, i18n.language]);

  const truncateText = (text: string, length: number) => {
    return text.length > length ? <>{text.slice(0, length)}... &nbsp;</> : text;
  };

  return (
    <section className="section-box box-flights background-body ac-home-news">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-md-9">
            <h3
              className="heading-3 mb-2 neutral-1000 wow fadeInUp ac-home-news__heading ac--font-expo"
              data-wow-duration={HOME_WOW_DURATION}
              data-wow-delay={homeWowDelay(0)}
            >
              {t("home.news.title")}
            </h3>
          </div>
        </div>
        <div
          className="ac-home-news__grid wow fadeInUp"
          data-wow-duration={HOME_WOW_DURATION}
          data-wow-delay={homeWowDelay(1)}
        >
          <Row className="ac-home-news__row" justify="space-between" gutter={[20, 20]}>
            {list.slice(0, 3).map((el: any) => (
              <Col key={el.id} xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                <div className="card-journey-small background-card hover-up ac-home-news__card">
                  <div className="card-image ac-home-news__media">
                    <img
                      className="ac-home-news__img"
                      src={el.image_1920}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <div className="card-info ac-home-news__body">
                    {el.tag_ids?.[0]?.name ? (
                      <div className="card-rating ac-home-news__tag-row">
                        <div className="card-left">
                          <span className="ac-home-news__tag">
                            {String(el.tag_ids[0].name).trim()}
                          </span>
                        </div>
                        <div className="card-right" />
                      </div>
                    ) : null}
                    <div className="card-title ac-home-news__title-wrap">
                      <span className="ac-home-news__headline">{el.name}</span>
                    </div>
                    <div className="card-program ac-home-news__program">
                      <p className="ac-home-news__excerpt">
                        {truncateText(el.summary, 200)}
                      </p>
                      <div className="ac-home-news__rule" aria-hidden />
                      <div className="endtime ac-home-news__footer">
                        <div className="card-price">
                          <p className="ac-home-news__date">
                            {moment(el.date)
                              .locale(i18n.language === "ar" ? "ar" : "en")
                              .format("MMMM D, YYYY")}
                          </p>
                        </div>
                        <div className="card-button">
                          <button
                            type="button"
                            className="ac-home-news__link"
                            onClick={() =>
                              navigate(`/news-detail`, {
                                state: {
                                  id: el.id,
                                  name: el.name,
                                  description: el.summary,
                                  details: el.details,
                                  image: el.image_1920,
                                  date: el.date,
                                  tags_ids: el.tag_ids,
                                },
                              })
                            }
                          >
                            {t("home.news.more")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </section>
  );
};

export default Blog;
